import { Button } from '@material-ui/core';
import React, { useCallback, useEffect, useState } from "react";
import { IMG_URL } from '../../config/config';
import { useDispatch, useSelector } from '../../store';

const ImageDetailsEditor = ({
	// image,
	// isAdmin,
	update
	// onSave = console.log
}) => {

	
	const isAdmin = useSelector(state => state.isAdmin);
	const image = useSelector(state => state.currentItem);

	const [payload, setPayload] = useState({ ...image })


	/** send only Changed Data */
	function handleSubmit() {
		const valuesToSend = getDiff(image, payload);
		if (Object.keys(valuesToSend).length > 0) {
			const p = [{
				publicId:image.publicId,
				...valuesToSend
			}]
			update(p);
		}

	}

	function getDiff(image, payload) {
		let valuesToSend = {}

		Object.keys(payload).forEach(key => {
			if (payload[key] != image[key] || (payload.key === '' && !image[key])) {
				valuesToSend[key] = payload[key]
			}
		})
		if(valuesToSend.tags){
			const stags = valuesToSend.tags;
				const newTags = stags.split(',')
					.map(tag => tag.trim().toLowerCase().split(' ').join('_'))
					.filter(a => a !== '')
					.sort((A, B) => A > B ? 1 : A < B ? -1 : 0)
				//removing duplicates	
				valuesToSend.tags = [...new Set(newTags)].join(',')
		}
		return valuesToSend
	}

	// console.log(`image`, image)
	const valuesToSend = getDiff(image, payload);
	// console.log(`valuesToSend`, valuesToSend)
	// console.log(`payload`, payload)

	const canSubmit = valuesToSend ? Object.keys(valuesToSend).length > 0 : false;
	return (

		<div className='ImageDetailsEditor'>
			<div className='row image-id'>{image?.publicId}  {image?.nsfw > 0 ? '[NSFW]' : ''}</div>

			<div className='row image-name'>
				<input
					style={{ width: '100%', fontSize: '120%', lineHeight: '120%', fontWeight: 'bold' }}
					value={payload?.name}
					onChange={e => setPayload({ ...payload, name: e.target.value })}
				/>
			</div>
			<div className='row image-description'>
				<div><label>Description:</label></div>
				<textarea
					style={{ width: '100%', height: '150px' }}
					value={payload.description}
					placeholder="description"
					onChange={e => setPayload({ ...payload, description: e.target.value })}
				/>
			</div>
			<div className='row image-tags'>
				<div><label>Tags:</label></div>
				<input
					style={{ width: '100%' }}
					value={payload.tags}
					onChange={e => setPayload({ ...payload, tags: e.target.value })}
				/>
			</div>
			<div className='row image-dates'>
				<span><label>Created: </label>{image.createdAt}</span>
				{image.upatedAt && <span><label>Updated:</label>{image.upatedAt}</span>}
			</div>
			<div className='row image-status'>
				<div style={{width:'45%',display:'inline-block',marginRight:'5px'}}>				
				<select
					value={payload.status}
					onChange={e => setPayload({ ...payload, status: e.target.value })}
				>
					{/* <select onChange={(e)=>setStatus(e.target.value)}> */}
					<option value="H">Hidden</option>
					<option value="D">Deleted</option>
					<option value="V">👁‍🗨 Visible</option>
					<option value="P">🙎‍♀️ Public</option>
					<option value="F">⭐Featured</option>
					<option value="N">New</option>

				</select>
				</div>
				<div style={{width:'50%',display:'inline-block'}}>				
				<select
					value={payload.nsfw}
					onChange={e => setPayload({ ...payload, nsfw: e.target.value })}
				>
					{/* <select onChange={(e)=>setStatus(e.target.value)}> */}
					<option value="0">Safe</option>
					<option value="1">Adult</option>
				</select>
				</div>
			</div>

			{isAdmin && <div className='image-origname'>
				<div><label>Original name:</label></div>
				<input
					style={{ width: '100%' }}
					value={payload.originalName}
					onChange={e => setPayload({ ...payload, originalName: e.target.value })}
				/>
			</div>}
			{isAdmin && <div className='image-info'>
				<div><label>Technical info:</label></div>
				<textarea
					style={{ width: '100%', height: '150px' }}
					value={payload.info}
					onChange={e => setPayload({ ...payload, info: e.target.value })}
				/>
			</div>}
			<div className="submitrow">
				{canSubmit ? <Button onClick={handleSubmit}>Sumbit</Button> : <Button disabled>Sumbit</Button>}
			</div>
		</div>

	)
}

export default ImageDetailsEditor